import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select";
import swal from "sweetalert";
import { addPanchkarmaUserAction, updatePanchkarmaUserAction } from "../../../store/actions/PanchkarmaActions/UserAction";
import { getRolesWithModulesAction } from "../../../store/actions/RoleAction";
import Loader from "../Common/Loader"
import { showErrorAlert } from "../../../services/ErrorHandlingService"

const AddPanchkarmaUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const editUser = location.state?.user || null

  const roles = useSelector((state) => state.role.roles)
  useEffect(() => {
    dispatch(getRolesWithModulesAction()) // <-- fetch roles when page loads
  }, [dispatch])
  // State to hold the user data
  const [user, setUser] = useState({
    role_id: "",
    admin_name: "",
    admin_username: "",
    admin_password: "",
    admin_cpassword: "",
    admin_email: "",
    admin_mobile: "",
    admin_status: "", // Active or Inactive
  });

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [errors, setErrors] = useState({})

  // const roleOptions = roles
  //   .filter((role) => role.role_id && role.role_name && role.role_name !== "Therapist") // exclude Therapist
  //   .map((role) => ({
  //     value: role.role_id,
  //     label: role.role_name,
  //   }))
  const roleOptions = roles
  .filter((role) => role.role_id && role.role_name && Number(role.role_id) > 7) // Only roles with role_id > 7
  .map((role) => ({
    value: role.role_id,
    label: role.role_name,
  }))


  // Status options for the dropdown
  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  useEffect(() => {
    if (editUser) {
      setFetching(true)
      setError("")
      setUser({
        edit_admin_id: editUser.admin_id,
        role_id: editUser.role_id || "",
        admin_name: editUser.admin_name || "",
        admin_username: editUser.admin_username || "",
        admin_password: "",
        admin_cpassword: "",
        admin_email: editUser.admin_email || "",
        admin_mobile: editUser.admin_mobile || "",
        admin_status: editUser.admin_status === "Active" ? "Active" : "Inactive",
      })
      setFetching(false)
    }
  }, [editUser])

  const isTherapistRole = roles.find(
    (r) => String(r.role_id) === String(editUser?.role_id)
  )?.role_name === "Therapist";

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };

  // Handle role selection
  const handleRoleChange = (selectedOption) => {
    setUser((prev) => ({
      ...prev,
      role_id: selectedOption ? selectedOption.value : "",
    }))

    // Clear selected diseases when role changes and disease dropdown should not show
    const newRoleLabel = selectedOption ? selectedOption.label : ""
    // const shouldShowDiseases = ["Telecaller", "Service Caller"].includes(newRoleLabel)
    // if (!shouldShowDiseases) {
    //   setSelectedDiseases([])
    // }
  }

  // Handle status selection
  const handleStatusChange = (selectedOption) => {
    setUser((prev) => ({
      ...prev,
      admin_status: selectedOption ? selectedOption.value : "",
    }))
  }

  const validate = () => {
    const newErrors = {}
    if (!/^[a-zA-Z\s]+$/.test(user.admin_name)) {
      newErrors.admin_name = "Full Name must contain only letters and spaces"
    }
    if (!user.role_id) newErrors.role_id = "Select One Role"

    if (!user.admin_username) newErrors.admin_username = "Enter Username"

    if (!user.admin_mobile.trim()) {
      newErrors.admin_mobile = "Contact Number is required"
    } else if (!/^\d{10}$/.test(user.admin_mobile)) {
      newErrors.admin_mobile = "Contact Number must be 10 digits"
    }
    if (!user.admin_email.trim()) {
      newErrors.admin_email = "Email Address is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.admin_email)) {
      newErrors.admin_email = "Enter a valid email address"
    }
    if (!user.admin_status) newErrors.admin_status = "Status is required"

    // const selectedRole = roleOptions.find((r) => String(r.value) === String(user.role_id))?.label

    // if (["Telecaller", "Service Caller"].includes(selectedRole)) {
    //   if (!extraFields.dailyCallingCapacity.trim()) {
    //     newErrors.dailyCallingCapacity = "Daily Calling Capacity is required"
    //   } else if (isNaN(extraFields.dailyCallingCapacity) || Number(extraFields.dailyCallingCapacity) <= 0) {
    //     newErrors.dailyCallingCapacity = "Must be a positive number"
    //   }

    //   if (selectedRole === "Service Caller") {
    //     if (!extraFields.maxActivePatients.trim()) {
    //       newErrors.maxActivePatients = "Maximum Active Patients is required"
    //     } else if (isNaN(extraFields.maxActivePatients) || Number(extraFields.maxActivePatients) <= 0) {
    //       newErrors.maxActivePatients = "Must be a positive number"
    //     }
    //   }
    // }
    if (!editUser) {
      // Required for new users
      if (!user.admin_password) newErrors.admin_password = "Enter password"
      if (!user.admin_cpassword) newErrors.admin_cpassword = "Confirm your password"
      if (user.admin_password !== user.admin_cpassword) {
        newErrors.admin_cpassword = "Passwords do not match"
      }
    } else {
      // Optional for edits, but must match if provided
      if (user.admin_password || user.admin_cpassword) {
        if (user.admin_password.length < 6) {
          newErrors.admin_password = "Password must be at least 6 characters"
        }
        if (user.admin_password !== user.admin_cpassword) {
          newErrors.admin_cpassword = "Passwords do not match"
        }
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Submit button clicked");
    setLoading(true)
    setError("")

    if (!validate()) {
      console.log("validate:", validate);
      setLoading(false)

      return
    }


    if (user.admin_password || user.admin_cpassword) {
      console.log("password:", user.admin_password);
      if (user.admin_password !== user.admin_cpassword) {

        showErrorAlert("Passwords do not match")
        setLoading(false)
        return
      }
    }


    const payload = {
      ...user,
    }

    const action = editUser
      ? updatePanchkarmaUserAction({ ...payload, admin_id: editUser.admin_id })
      : addPanchkarmaUserAction(payload)

    dispatch(action)
      .then(() => {
        navigate("/panchkarma-users", {
          state: location.state?.returnTo || {}, // pass back pagination/search/sort state
        })
      })
      .catch(() => {
        showErrorAlert(`Failed to ${editUser ? "update" : "add"} user`)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  if (loading || fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "20px",
              }}
            >
              <Link to="/panchkarma-users" className="btn btn-link">
                <Button variant="primary">Back</Button>
              </Link>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="admin_name"
                    placeholder="Enter Full Name"
                    value={user.admin_name}
                    onChange={handleChange}
                    disabled={isTherapistRole}
                  />
                  {errors.admin_name && <small className="text-danger">{errors.admin_name}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Email Address</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="email"
                    className="form-control"
                    name="admin_email"
                    placeholder="Enter Email Address"
                    value={user.admin_email}
                    onChange={handleChange}
                  />
                  {errors.admin_email && <small className="text-danger">{errors.admin_email}</small>}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Contact Number</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="tel"
                    className="form-control"
                    name="admin_mobile"
                    maxLength="10"
                    placeholder="Enter Contact Number"
                    value={user.admin_mobile}
                    onChange={handleChange}
                  />
                  {errors.admin_mobile && <small className="text-danger">{errors.admin_mobile}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Role</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="role_id"
                    options={roleOptions}
                    value={roleOptions.find((opt) => String(opt.value) === String(user.role_id)) || null}
                    onChange={handleRoleChange}
                    placeholder="Select Role"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.role_id && <small className="text-danger">{errors.role_id}</small>}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Username</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="admin_username"
                    placeholder="Enter Username"
                    value={user.admin_username}
                    onChange={handleChange}
                    disabled={!!editUser}
                  />
                  {errors.admin_username && <small className="text-danger">{errors.admin_username}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Password {editUser ? "(leave blank to keep current)" : ""}</label>
                  {!editUser && <span style={{ color: "red" }}>*</span>}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="admin_password"
                      placeholder="Enter Password"
                      value={user.admin_password}
                      onChange={handleChange}
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                        //zIndex: 1,
                      }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>

                  {errors.admin_password && <small className="text-danger">{errors.admin_password}</small>}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="admin_status"
                    options={statusOptions}
                    value={statusOptions.find((opt) => opt.value === user.admin_status) || null}
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.admin_status && <small className="text-danger">{errors.admin_status}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">
                    Confirm Password {editUser ? "(leave blank to keep current)" : ""}
                  </label>
                  {!editUser && <span style={{ color: "red" }}>*</span>}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showCPassword ? "text" : "password"}
                      className="form-control"
                      name="admin_cpassword"
                      placeholder="Enter Password"
                      value={user.admin_cpassword}
                      onChange={handleChange}
                    />
                    <span
                      onClick={() => setShowCPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                        //zIndex: 1,
                      }}
                    >
                      {showCPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>

                </div>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading || fetching}>
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  <>{editUser ? "Update User" : "Add User"}</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPanchkarmaUser;
